import axios from "axios";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Image } from "react-bootstrap";
import { baseURL, LOGIN } from "../../../Api/Api";
import "./LoginDash.css";
import Alert from "react-bootstrap/Alert";
import Cookie from "cookie-universal";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();

  const [showAlert, setShowAlert] = useState(false); // To control alert visibility

  const [err, setErr] = useState();

  // Cookies
  const cookie = Cookie();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault(); // Corrected the typo here
    try {
      const res = await axios.post(`${baseURL}/${LOGIN}`, {
        email: form.email,
        password: form.password,
      });
      console.log(res);

      // Set the token in a cookie
      const token = res.data.token;
      cookie.set("dashboardLogin", token);

      // Check the user role from the response
      const userRole = res.data.role; // Assuming 'role' is returned from the backend
      cookie.set("userRole", userRole);

      // Redirect based on the user's role
      if (userRole === "admin") {
        navigate("/panel"); // Redirect to panel for admin
      } else {
        navigate("/"); // Redirect to home page for non-admin users
      }
    } catch (error) {
      console.log(
        "Error: ",
        error.response ? error.response.data : error.message
      );
    }
  }

  // Show the alert when an error is set
  useEffect(() => {
    if (err !== "") {
      setShowAlert(true); // Show alert if there is an error
      setTimeout(() => {
        setShowAlert(false); // Hide alert after 2 seconds
      }, 2000);
    }
  }, [err]); // Dependency on `err`, so this effect only runs when `err` changes

  return (
    <>
      {/* Preloader */}
      {/* <div id="preloader" className="preloader">
        <div className="inner">
          <div className="line1" />
          <div className="line2" />
          <div className="line3" />
        </div>
      </div> */}

      {/* Main Section */}
      <section
        className="fxt-template-animation fxt-template-layout34"
        data-bg-image="/assets/dashboard/images/bg1.png"
      >
        <div className="fxt-shape">
          <div className="fxt-transformX-L-50 fxt-transition-delay-1">
            <Image src="/assets/dashboard/images/shape1.png" alt="Shape" />
          </div>
        </div>
        <div className="container">
          <div className="row">
            {/* Left Column */}
            <div className="col-lg-8">
              <div className="fxt-column-wrap justify-content-between">
                <div className="fxt-animated-img">
                  <div className="fxt-transformX-L-50 fxt-transition-delay-10">
                    <img
                      src="/assets/dashboard/images/bg34-1.png"
                      alt="Animated Image"
                    />
                  </div>
                </div>
                <div className="fxt-transformX-L-50 fxt-transition-delay-3">
                  <a href="#" className="fxt-logo">
                    <img
                      src="/assets/dashboard/images/logo-34.png"
                      alt="Logo"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Right Column (Login Form) */}
            <div className="col-lg-4">
              <div className="fxt-column-wrap justify-content-center">
                <div className="fxt-form">
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        id="email"
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Enter email"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        id="password"
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        placeholder="Password"
                        required
                      />
                    </Form.Group>

                    <Button type="submit" className="fxt-btn-fill mb-3">
                      Submit
                    </Button>
                    {showAlert && (
                      <Alert
                        key="danger"
                        variant="danger"
                        className={showAlert ? "" : "d-none"}
                      >
                        <span>{err}</span>
                      </Alert>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
